/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const TaskSlice = createSlice({
  name: 'task',
  initialState: {
    tasks:[],
    documents:[]
  },
  reducers: {
    setAllTasks: (state, action) => {
      state.tasks = action.payload;
    },
    setAddAndUpdateTask: (state, action) => {
        const newTask = action.payload
        const index = state.tasks.findIndex(task => task?._id === newTask?._id)
        if (index !== -1) {
            state.tasks[index] = newTask
        }else{
            state.tasks.unshift(newTask)
        }
    },
    setTaskDocuments: (state, action) => {
        state.documents = action.payload;
      },
    setAddAndUpdateDocuments: (state, action) => {
        const newDocument = action.payload
        const index = state.documents.findIndex(doc => doc?._id === newDocument?._id)
        if (index !== -1) {
            state.documents[index] = newDocument
        }else{
            state.documents.unshift(newDocument)
        }
    },
  },
});

export const {
  setAllTasks, setAddAndUpdateTask, setTaskDocuments, setAddAndUpdateDocuments
} = TaskSlice.actions;

export default TaskSlice.reducer;
